import { apiRequest } from "./apiClient";
export const fetchFiles = async (patientId) => {
  return await apiRequest({
    method: "GET",
    endpoint: `/files?patient_id=${patientId}`,
  });
};

export const saveFile = async (payload) => {
  return await apiRequest({
    method: "POST",
    endpoint: "/files",
    body: payload,
  });
};

export const deleteFiles = async (fileId) => {
  return await apiRequest({
    method: "GET", 
    endpoint: `/files/${fileId}`,
  });
};